import { IBilledCenterForList } from '@nkr/models/index';
import { Button } from 'react-bootstrap';

interface IProps {
    data: IBilledCenterForList,
    onViewCharges: (donorId: number) => void
}

const BilledToCenterRow = (props: IProps) => {
    const handleViewCharges = () => {
        props.onViewCharges(props.data.donorId);
    };

    const { transplantDate, donorAlias, donorCenterAlias, donorRdnCenterAlias, recipientAlias, recipientCenterAlias, claimType, isGlobal,
        physicianCharges, asaUnits, asaUnitPrice, anesthesiaCharges, hospitalCharges,
        chainId, clusterNumber, positionNumber, statusDescription, disputedBy, billedBy,
        invoiceDate } = props.data;

    const total = physicianCharges + (isGlobal ? asaUnits * asaUnitPrice : anesthesiaCharges) + hospitalCharges;
    const swapNumber = chainId != 0 && clusterNumber != 0 && positionNumber != 0 ? chainId + '/' + clusterNumber + '/' + positionNumber : '';

    const billedByNkr = billedBy == "NKR";

    return (
        <tr>
            <td>{transplantDate}</td>
            <td>{swapNumber}</td>
            <td>{donorCenterAlias} {donorRdnCenterAlias != '' ? <span style={{ color: 'darkred' }}>({donorRdnCenterAlias})</span> : null}</td>
            <td>{donorAlias}</td>
            <td>{recipientCenterAlias}</td>
            <td>{recipientAlias}</td>
            <td>{claimType}</td>
            <td>${total.toLocaleString('en', { minimumFractionDigits: 2 })}</td>
            <td>{statusDescription}</td>
            <td>{disputedBy}</td>
            <td>{billedBy}</td>
            <td>{invoiceDate}</td>

            <td style={{ textAlign: 'center' }}>
                {billedByNkr
                    && <Button bsStyle='primary' bsSize='xs' target={"_blank"} href={"https://www.kidneyregistry.com/membership-terms-legacy"}>Terms & Conditions</Button>
                }

                {!billedByNkr
                    && <Button bsStyle='primary' bsSize='xs' target={"_blank"} onClick={handleViewCharges}>Review Bill</Button>
                }
            </td>
        </tr>
    );
}

export default BilledToCenterRow;